export default __webpack_public_path__ + "static/media/AAM banner link online 1300_400.c0974723.png";